// extracted by mini-css-extract-plugin
export default {"msg-success":"PopupMessage_msg-success__qKfpy","msg-warning":"PopupMessage_msg-warning__1zH2j","msg-error":"PopupMessage_msg-error__4Vhxe"};